import {FC, useMemo} from 'react'
import {ViewOrderSummary} from 'app/features/orders/componentsv1'
import {PaymentStatus} from 'app/features/orders/componentsv1/shared'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {selectViewOrder, selectViewOrderItems} from 'app/features/orders/redux/order/orderSlice'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {simpleCurrency} from 'app/format/currency'
import PrintOrderInvoice from 'app/features/orders/componentsv1/view/PrintOrderInvoice'

interface Props {}

export const PaymentWrapper: FC<Props> = () => {
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)
  const orderItems = useSelector(selectViewOrderItems)

  const discountTitle = useMemo(() => {
    let wineClubDiscountTitle, discountTitle, shippingTitle, isShippingFree
    if (viewOrder.discounts) {
      const {isPromoCode, isWineClub, isFreeShipping} = viewOrder.discounts
      if (isPromoCode) {
        discountTitle = viewOrder.discounts.discountCode
        const {isPromoDiscountOverride, promoCustomPercentage} = viewOrder.discounts
        if (isPromoDiscountOverride) {
          discountTitle = promoCustomPercentage
            ? `${promoCustomPercentage} % Discount`
            : `${simpleCurrency(viewOrder.totalDiscounts)} Discount`
        }
      }
      if (isWineClub) {
        const {name, isWineClubDiscountOverride, wineClubCustomPercentage} = viewOrder.discounts
        wineClubDiscountTitle = name
        if (isWineClubDiscountOverride) {
          wineClubDiscountTitle = wineClubCustomPercentage
            ? `${wineClubCustomPercentage} % Discount`
            : `${simpleCurrency(viewOrder.wineClubDiscounts)} Discount`
        }
      }
      if (isFreeShipping) {
        shippingTitle = viewOrder.discounts.freeShipCode ?? viewOrder.discounts.freeShipName
      }
      isShippingFree = isFreeShipping
    }
    return {wineClubDiscountTitle, discountTitle, shippingTitle, isFreeShipping: isShippingFree}
  }, [viewOrder.discounts, viewOrder.totalDiscounts, viewOrder.wineClubDiscounts])

  return (
    <ViewOrderSummary
      items={orderItems}
      {...viewOrder}
      {...discountTitle}
      paymentMethod={viewOrder.customer.paymentMethod}
      title={<PaymentStatus status={viewOrder.financialStatus} />}
      shippingRate={viewOrder.shippingRate}
      isCrv={viewOrder.isCrvEnabled}
      wineClubDiscountChild={
        viewOrder.isAutoDiscountRemoved && (
          <span className='text-muted'>( Auto discount removed )</span>
        )
      }
      taxTitle={viewOrder.isTaxRemoved && <span className='text-muted'>( Tax Removed )</span>}
      toolbar={<PrintOrderInvoice order={viewOrder} />}
    />
  )
}

export default PaymentWrapper
